import React, { useMemo, useState } from 'react';
import { Row, Col, Tabs } from 'antd';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { API_STATUS, DATE_FORMAT } from 'constants/app-constants';
import DatePicker from 'components/date-picker';
import PaymentListFunctional from './payment-list-functional';
import { useI18n } from 'hooks/useI18n';

import { CreditCard, ShoppingBag, Dumbbell } from 'lucide-react'; // ✅ Lucide icons

const PaymentsTab = () => {
	const globalRedux = useSelector((state) => state.globalRedux);
	const { t } = useI18n();
	const tableLoading = useMemo(() => globalRedux.apiStatus.GET_PAYMENTS === API_STATUS.PENDING, [globalRedux.apiStatus]);
	const [month, setMonth] = useState(dayjs());

	const onMonthChange = (selectedMonth) => {
		setMonth(selectedMonth);
	};

	const tabItems = [
		{
			key: 'Memberships',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<CreditCard size={16} />
					{t('payments.tabs.memberships')}
				</span>
			),
			disabled: tableLoading,
			children: <PaymentListFunctional paymentType="membership" month={month} />,
		},
		{
			key: 'Products',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<ShoppingBag size={16} />
					{t('payments.tabs.products')}
				</span>
			),
			disabled: tableLoading,
			children: <PaymentListFunctional paymentType="product" month={month} />,
		},
		{
			key: 'PersonalTraining',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<Dumbbell size={16} />
					{t('payments.tabs.personal_training')}
				</span>
			),
			disabled: tableLoading,
			children: <PaymentListFunctional paymentType="personalTraining" month={month} />,
		},
	];

	return (
		<Row className="payments-tab-container" style={{ height: '80%' }}>
			<Col span={24} className="container">
						<Row style={{ paddingTop: 20, marginBottom: 16 }}>
					<Col span={24}>
						<span style={{ marginRight: 8 }}>{t('payments.select_month')}:</span>
						<DatePicker
							allowClear={false}
							style={{ width: 180 }}
							picker="month"
							value={month}
							format={DATE_FORMAT.MMM_YYYY}
							onChange={onMonthChange}
						/>
					</Col>
				</Row>

				<Tabs defaultActiveKey="Memberships" destroyInactiveTabPane items={tabItems} />
			</Col>
		</Row>
	);
};

export default PaymentsTab;
